<template>
  <div>
    <div class="alert alert-info" role="alert" v-show="message.success">
      {{ message.success }}
    </div>
    <div class="alert alert-danger" role="alert" v-show="message.error">
      {{ message.error }}
    </div>
    <div class="text-center mt-2" v-show="message.success">
      <router-link class="btn btn-link" :to="{ name: 'Login'}">Go to Login</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfirmEmail',
  data() {
    return {
      message: {
        success: false,
        error: false
      }
    }
  },
  created() {
    this.$http
      .post(
        'user/me/activate-account',
        { hash: 'nothing' },
        { params: { authToken: this.$route.query.confirmToken } }
      )
      .then(
        response => {
          this.showSuccessMessage('You account is activated successfully!')
        },
        err => {
          this.showErrorMessage('Someting is wrong with this activation!')
          console.log(err)
        }
      )
  },
  methods: {
    hideErrorMessage() {
      this.message.error = false
    },
    showErrorMessage(message) {
      this.message.error = message
    },
    showSuccessMessage(message) {
      this.message.success = message
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/pages/auth/ConfirmEmail.vue